import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-inline-rename',
  templateUrl: './inline-rename.component.html',
  styleUrls: ['./inline-rename.component.css']
})
export class InlineRenameComponent {
  @Input() placeholder = 'Click to modify...';
  @Input() actionLabel: string = "Modify";
  @Input() multiLines: boolean = false;

  isSingleClick: Boolean = false;     



  @Input() itemName = 'Item Name';

  @Input() clickable: 'single' | 'double' | false = 'single';

  @Input() isEditing = false;
  @Output() isEditingChange = new EventEmitter<boolean>();

  @Output() onSave = new EventEmitter<string>();

  startEditing() {
    this.isEditing = true;
    this.isEditingChange.emit(true);
  }

  stopEditing() {
    this.isEditing = false;
    this.isEditingChange.emit(false);
  }

  saveName(newName: string) {
    this.itemName = newName;
    this.onSave.emit(newName);
    this.stopEditing();
  }


  onClick() {
    if (this.clickable === 'single') {
      this.startEditing();
      return;
    }
    if (this.clickable === 'double' && !this.isSingleClick) {
      this.isSingleClick = true;  
      setTimeout(() => {
        this.isSingleClick = false;  
      }, 250);
      
      return;
    }


    if (this.clickable === 'double' && !!this.isSingleClick) {
      this.onDoubleClick()
      return;
    }
    
  }

  onDoubleClick() {
    this.startEditing();
  }
}
